import React, { CSSProperties } from "react";
import "./styles.scss";

type propsType = {
    color?: CSSProperties["color"];
    flip?: boolean;
    reverse?: boolean;
    zIndex?: CSSProperties["zIndex"];
};

export const WaveInverse: React.FC<propsType> = (props: propsType) => {
    const { color = "#fff", flip = false, reverse = false, zIndex = 0 } = props;
    const styleWave = {
        marginBottom: -5,
        transform: "",
        marginTop: reverse ? -5 : 5,
    };
    if (flip) {
        styleWave.transform += " scaleX(-1)";
    }
    if (reverse) {
        styleWave.transform += " scaleY(-1)";
    }
    return (
        <div
            data-testid="WaveInverse"
            style={{ display: "inline-block", zIndex }}
            className="wave wave--inverse"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 1280.11 140.37"
                style={styleWave}
            >
                <path
                    d="M 0,140.37 V 0 S 174.64,101.77,384.2,100.77,724.43,1.45,928.11,49.36,1280.11,0,1280.11,0 V 140.37 Z"
                    fill={color}
                />
            </svg>
        </div>
    );
};
